import { ApplicationState, AppThunkDispatch } from "../store";
import { connect } from "react-redux";
import ReportForm  from "../components/Forms/ReportForm";
import { ReportEntity } from "../store/entities/state";
import { isSubmittingNew, getChangingValue, getChangingState } from "../store/entities/selectors";
import { entityCreatingCancel, updateChangingEntity, updateEntity } from "../store/entities/actions";
import { ReportFormDispatchProps, ReportFormStateProps } from "../components/Forms/ReportForm";
import { updateClientReportAsync } from "../ajax/requests";
import { getCompanyLogo } from "../store/settings/selectors";
import { getAiScriberReportDraft, getAiScriberSelectedTemplateId } from "../store/aiScriber/selectors";


const mapStateToProps = (state: ApplicationState): ReportFormStateProps => {
    const report = getChangingValue(state, 'reports') as ReportEntity;
    const draft = getAiScriberReportDraft(state);
    const selectedTemplateId = getAiScriberSelectedTemplateId(state);
    const draftMatchesTemplate = draft !== undefined && report?.templateId === selectedTemplateId;

    return {
        companyLogo: getCompanyLogo(state),
        report,
        hasChanged: getChangingState(state, 'reports'),
        loading: isSubmittingNew(state, 'reports'),
        readOnly: false,
        aiSuggestions: draftMatchesTemplate
            ? Object.fromEntries(draft!.fields.map(f => [f.label, f.value]))
            : undefined,
        aiAdditionalNotes: draftMatchesTemplate && draft!.aiAdditionalNotes
            ? draft!.aiAdditionalNotes
            : undefined,
        aiWarnings: draftMatchesTemplate && draft!.warnings.length > 0
            ? [...draft!.warnings]
            : undefined,
    };
};

const mapDispatchToProps = (dispatch: AppThunkDispatch): ReportFormDispatchProps => ({
    onChange: (data: ReportEntity) => dispatch(updateChangingEntity('reports', data)),
    onClose: () => dispatch(entityCreatingCancel('reports')),
    onSubmit: (clientId: string, data: ReportEntity) => dispatch(updateEntity('reports', data, r => updateClientReportAsync(clientId, r))),
});

const ReportCreateForm = connect<ReportFormStateProps, ReportFormDispatchProps, unknown, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps,
)(ReportForm as any);

export default ReportCreateForm;